var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6113 2.42859C16.9196 2.42859 21.2227 6.63693 21.2227 11.828C21.2226 14.2772 20.2637 16.5067 18.6943 18.1796L21.7822 21.1923C22.0716 21.4745 22.0726 21.9326 21.7842 22.2157C21.5217 22.473 21.1104 22.4969 20.8203 22.287L20.7373 22.2177L17.6104 19.1678C15.9658 20.455 13.8816 21.2274 11.6113 21.2274C6.30317 21.2273 2.00008 17.0189 2 11.828C2 6.637 6.30312 2.4287 11.6113 2.42859ZM11.6113 3.87585C7.12074 3.87597 3.48047 7.43657 3.48047 11.828C3.48055 16.2194 7.12079 19.7791 11.6113 19.7792C16.102 19.7792 19.7421 16.2194 19.7422 11.828C19.7422 7.4365 16.102 3.87585 11.6113 3.87585Z",
    fill: "#11142D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.7495d6c45e01bd7bf91a98e124f422fc.svg";
export { ForwardRef as ReactComponent };